export const initialise = () => {
    const dialog = document.querySelector<HTMLDialogElement>('.new-quick-search-overlay')
    if (!dialog) return

    const buttonClose = dialog.querySelector<HTMLElement>('.new-quick-search-overlay__close-btn')
    const buttonOpen = document.querySelector<HTMLElement>('.new-main-header__search-icon-mob')
    const searchWidget = dialog.querySelector<HTMLElement>('.dialog-search-overlay__widget-search')
    if (!buttonClose || !buttonOpen || !searchWidget) return

    bindEvents(dialog, buttonClose, buttonOpen)
    autocompleteSuggestions(searchWidget)
    locationAutocompleteSuggestions(searchWidget)
}

const openOverlay = (dialog: HTMLDialogElement) => {
    if (dialog.open) return
    dialog.showModal()
    document.body.classList.add('nav-open')
}

const closeOverlay = (dialog: HTMLDialogElement) => {
    if (!dialog.open) return
    dialog.close()
    document.body.classList.remove('nav-open')
}

const bindEvents = (dialog: HTMLDialogElement, buttonClose: HTMLElement, buttonOpen: HTMLElement) => {
    buttonOpen.addEventListener('click', () => {
        openOverlay(dialog)
    })

    buttonClose.addEventListener('click', () => {
        closeOverlay(dialog)
    })

    dialog.addEventListener('close', () => {
        document.body.classList.remove('nav-open')
    })
}

const autocompleteSuggestions = (searchWidget: HTMLElement) => {
    const autocompleteSuggestion = document.querySelector('.dialog-search-overlay__widget-search.autocomplete-suggestions')
    if (!autocompleteSuggestion) return

    autocompleteSuggestion.setAttribute('popover', '')
    searchWidget.appendChild(autocompleteSuggestion)
}

const locationAutocompleteSuggestions = (searchWidget: HTMLElement) => {
    const locationInput = searchWidget.querySelector<HTMLDivElement>('.location-filter')
    locationInput?.addEventListener('input', () => {
        const locationAutocompleteSuggestion = document.querySelector('.active-search-container.pac-container');
        if (locationAutocompleteSuggestion) {
            locationAutocompleteSuggestion.setAttribute('popover', '')
            locationInput.appendChild(locationAutocompleteSuggestion)
        }
    })
};